import { render, staticRenderFns } from "./NotaCredito.vue?vue&type=template&id=23f4a356&"
import script from "./NotaCredito.vue?vue&type=script&lang=js&"
export * from "./NotaCredito.vue?vue&type=script&lang=js&"
import style0 from "./NotaCredito.vue?vue&type=style&index=0&id=23f4a356&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports